<section class="aikosh-hero position-relative text-white overflow-hidden">
  <!-- Left Side Subtle Amber/Glow Layer -->
  <div class="glow-layer position-absolute top-0 start-0 h-100 pointer-events-none"></div>

  <!-- Background Abstract Subtle Vector Shape -->
  <div class="vector-shape position-absolute top-0 start-0 h-100 pointer-events-none opacity-25"></div>

  <div class="container position-relative z-1">
    <div class="row align-items-center">
      <!-- Left Typography Content -->
      <div class="col-lg-8 col-md-8 text-start ps-lg-4">
        <!-- Heading Block -->
        <h1 class="fw-bold mb-3">
          <span class="d-block">Bring India's</span>
          <span class="d-block">
            national <span class="highlight-text">AI infrastructure</span>
          </span>
          <span class="d-block">to your campus.</span>
        </h1>
        
        <!-- Paragraph Block -->
        <p class="hero-desc mb-2 text-secondary-emphasis">
        The AIKosh University Engagement
Programme invites universities to
participate in India's national AI
ecosystem. Students across all
disciplines can access datasets, AI
models, workshops, and hackathons
through the platform.

        </p>
        
        <!-- Button Component -->
       <div class="pt-3 d-flex gap-3 flex-column flex-sm-row justify-content-center justify-content-sm-start text-center align-items-center">
  <div class="d-flex border border-white rounded-3 align-items-center justify-content-center px-4 py-2 w-sm-50" (click)="navigateToPDFLink()" style="cursor: pointer;">
    <button class="bg-transparent border-0 text-white p-0 me-2 fw-semibold">
      Call for Proposals
    </button>
    <img src="images/proposal.svg" width="20" height="20" alt="AIKosh Presenter"/>
  </div>
  
  <button class="btn btn-light rounded-3 px-4 py-2 fw-semibold text-dark shadow-sm  w-sm-50" (click)="navigateToRegister()">
    Register Interest
  </button>
</div>


      </div>

      <!-- Right Image Block -->
      <div class="col-lg-4 col-md-4 position-relative d-flex justify-content-end align-items-end pt-md-0">
        <!-- Curved Panel Structural Card -->
        <div class="position-absolute bottom-0 end-0 h-100 w-100 rounded-4 opacity-10"></div>
        <!-- Main Person Banner Graphics Wrapper -->
        <img src="/images/person.svg" class="hero-image img-fluid position-relative z-2" alt="AIKosh Presenter"/>
      </div>
    </div>
  </div>
</section>